<template>
  <v-container fluid>
    <v-overlay :value="this.loading">
      <v-progress-circular
          indeterminate
          size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-row class="d-flex justify-end align-center pa-5">
      <v-switch
          v-model="isV2Algorithm"
          :label="$t('trending algorithm')"
          color="#ff0000"
          hide-details
          :loading="algorithmLoading"
          :disabled="algorithmLoading"
          @change="onToggleAlgorithm"
      />
      <v-spacer></v-spacer>
      <v-btn v-if="isV2Algorithm" color="#ff0000" class="white--text" tile width="120" @click="navigateAdd">
        + {{$t('new video')}}
      </v-btn>
    </v-row>
    <v-row>
      <v-col
          class="d-flex align-center"
          xl="6"
          lg="6"
          md="6"
          sm="12"
          xs="12"
          cols="6">
        <div class="d-flex search-box align-center pl-2 mb-2">
          <v-text-field
              v-model="searchKeyword"
              v-on:keyup="searchKeydown"
              :label="`${$t('search')}`"
              hide-no-data
              hide-details
              dense
              flat
              solo
          />
          <v-btn icon  @click="initVariables">
            <v-icon color="black">mdi-magnify</v-icon>
          </v-btn>
        </div>
      </v-col>
      <v-spacer></v-spacer>
      <v-col
          class="d-flex align-center"
          xl="3"
          lg="3"
          md="4"
          sm="12"
          xs="12"
          cols="4">
        <v-select
            class="lang-select mx-2"
            v-model="selectedLang"
            :items="languages"
            item-text="name"
            item-value="val"
            single-line
            outlined
            dense
            hide-details
        />
      </v-col>
    </v-row>
    <v-row class="d-flex flex-wrap py-4" no-gutters>
      <v-col
          xl="4"
          lg="4"
          md="6"
          sm="6"
          xs="12"
          cols="12"
          v-for="(video, index) in videos"
          :key="(video.video_position ? 'vp-' + video.video_position.id : 'v-' + video.id) + '-' + index"
      >
        <feed-video-item
            :video="video"
            :index="index"
            :hide-lock-menu="true"
            @removeFeed="onRemoveVideoFromFeed"
            @addVideoToSection="onShowVideoSectionDlg"
        />

      </v-col>
      <div ref="loadMoreTrigger" style="height: 1px;"></div>
    </v-row>
    <v-dialog
        v-model="showVideoSectionDlg"
        max-width="480"
    >
      <v-card class="pa-10">
        <v-card-title class="text-h6 font-weight-bold pa-0 mb-5">
          {{ $t('add to session') }}
        </v-card-title>
        <div class="d-flex align-center">
          <span class="text-caption ml-4">{{ $t('category') }}</span>
          <v-select
              class="category-select"
              v-model="videoPosition['category_id']"
              :items="categories"
              item-text="name"
              item-value="id"
              single-line
              outlined
              dense
              hide-details
          />
        </div>
        <div class="d-flex align-center mt-4">
          <span class="text-caption ml-3">{{ $t('location') }}</span>
          <v-select
              class="category-select"
              v-model="videoPosition['position']"
              :items="positions"
              single-line
              outlined
              dense
              hide-details
          />
        </div>

        <v-card-actions class="d-flex justify-space-between px-0 mt-10">
          <v-btn
              class="white--text flex-grow-1"
              color="#616161"
              tile
              x-large
              @click="showVideoSectionDlg = false"
          >
            <span class="text-h5">{{ $t('cancel') }}</span>
          </v-btn>
          <v-btn
              class="white--text flex-grow-1"
              color="#ff0000"
              tile
              x-large
              @click="onAddVideoToSection()"
          >
            <span class="text-h5">הוסף</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showDeleteDlg" max-width="290">
      <v-card>
        <v-card-title class="text-subtitle-2" > אתה בטוח? </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="showDeleteDlg = false">
            לֹא
          </v-btn>

          <v-btn color="green darken-1" text @click="onCleanVideosFromFeed()">
            כֵּן
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import api from "@/api/api";

export default {
  data() {
    let languages = [
      {name: this.$t("hebrew"), val: "he"},
      {name: this.$t("english"), val: "en"},
    ];
    return {
      limit: 25,
      offset: 0,
      searchKeyword: null,
      videos: [],
      categories: null,
      showVideoSectionDlg: false,
      selectedVideo: null,
      videoPosition: {},
      positions: [...Array(25).keys()].map(p => p + 1),
      languages: languages,
      selectedLang: languages[0].val,
      showDeleteDlg: false,
      loading: false,
      loadMoreObserver: null,
      hasUserScrolled: false,

      isV2Algorithm: false,
      algorithmLoading: false,
    };
  },
  mounted() {
    this.fetchAlgorithmSetting();
    this.getCategories();
    this.getData();

    window.addEventListener('scroll', this.handleScroll);
  },
  watch: {
    selectedLang: {
      handler: function () {
        this.getCategories();
        this.initVariables();
      }
    }
  },
  methods: {
    handleScroll() {
      if (this.hasUserScrolled) return;

      this.hasUserScrolled = true;
      this.setupLoadMoreObserver();

      window.removeEventListener('scroll', this.handleScroll);
    },
    setupLoadMoreObserver() {
      if (this.loadMoreObserver) return;

      this.loadMoreObserver = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) {
          this.loadMore()
        }
      })
      this.loadMoreObserver.observe(this.$refs.loadMoreTrigger);
    },
    fetchAlgorithmSetting() {
      this.algorithmLoading = true;
      api.getSystemSetting('trending_algorithm')
          .then((res) => {
            this.isV2Algorithm = res.data.value === 'v2';
            this.algorithmLoading = false;
          })
          .catch((err) => {
            console.log(err);
            this.isV2Algorithm = false;
            this.algorithmLoading = false;
          });
    },
    onToggleAlgorithm(isV2) {
      this.algorithmLoading = true;
      const value = isV2 ? 'v2' : 'legacy';

      api.updateSystemSetting('trending_algorithm', value)
          .then(() => {
            this.algorithmLoading = false;
            this.offset = 0;
            this.getData();
          })
          .catch((err) => {
            console.log(err);
            this.algorithmLoading = false;
            this.isV2Algorithm = !isV2;
          });
    },
    getCategories() {
      this.$store.dispatch("SET_TOOLBARLOAD", true);
      this.categories = [];
      api.getCategories(this.selectedLang, true)
          .then((res) => {
            this.$store.dispatch("SET_TOOLBARLOAD", false);
            this.categories = res.data.categories;
          })
          .catch((err) => {
            this.$store.dispatch("SET_TOOLBARLOAD", false);
            console.log(err);
          })
    },
    getData() {
      this.$store.dispatch("SET_TOOLBARLOAD", true);
      const params = {
        limit: this.limit,
        offset: this.offset,
        term: this.searchKeyword,
      };
      api.getTrendingVideos(params, this.selectedLang)
          .then(res => {
            this.$store.dispatch("SET_TOOLBARLOAD", false);
            const videos = res.data.videos

            if (this.offset === 0) {
              this.videos = videos
            } else {
              this.videos = [...this.videos, ...videos]
            }
          })
          .catch((err) => {
            this.$store.dispatch("SET_TOOLBARLOAD", false);
            this.videos = [];
            console.log(err);
          })
    },
    initVariables() {
      this.offset = 0;
      this.getData();
    },
    searchKeydown(e) {
      if (e.keyCode === 13) {
        this.initVariables();
      }
    },
    onRemoveVideoFromFeed(video) {
      this.$store.dispatch("SET_TOOLBARLOAD", true);
      this.showDeleteDlg = true;
      this.selectedVideo = video;
    },
    onShowVideoSectionDlg(video) {
      this.showVideoSectionDlg = true;
      this.selectedVideo = video;
    },
    onAddVideoToSection() {
      this.$store.dispatch("SET_TOOLBARLOAD", true);
      const data = {
        video_id: this.selectedVideo.id,
        category_id: this.videoPosition.category_id,
        position: this.videoPosition.position
      };
      api.createVideoPosition(data)
          .then(() => {
            this.$store.dispatch("SET_TOOLBARLOAD", false);
            this.selectedVideo = null;
            this.showVideoSectionDlg = false;
            this.offset = 0;
            this.getData();
          })
          .catch((err) => {
            this.$store.dispatch("SET_TOOLBARLOAD", false);
            console.log(err);
          })
    },
    onCleanVideosFromFeed() {
      this.showDeleteDlg = false;
      this.$store.dispatch("SET_TOOLBARLOAD", true);
      this.loading = true;
      api.deleteTrendingVideo(this.selectedVideo.id)
          .then(() => {
            this.$store.dispatch("SET_TOOLBARLOAD", false);
            this.offset = 0;
            this.getData();
            this.loading = false;
          })
          .catch((err) => {
            this.$store.dispatch("SET_TOOLBARLOAD", false);
            console.log(err);
            this.offset = 0;
            this.getData();
            this.loading = false;
          })
    },
    navigateAdd() {
      this.$router.push({ path: `/trending/add` });
    },
    loadMore() {
      this.offset += this.limit;
      this.getData();
    },
  }
}
</script>

<style scoped>
@media (max-width:600px) {
  .search-box {
    width: 100%;
    border: 1px solid black
  }
}

@media (min-width: 600px) and (max-width: 1264px) {
  .search-box {
    width: 40%;
    border: 1px solid black
  }
}

@media (min-width: 1264px) {
  .search-box {
    width: 30%;
    border: 1px solid black
  }
}


.lang-select {
  border-radius: 0px;
  max-width: 250px;
}

.lang-select {
  border-radius: 0px;
  max-width: 250px;
}
</style>
